/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { getErrorToast } from "../../pages/ToastMessages";
import { SignOut } from "../Auth";
import { Export } from "../../models/Export";


const GetToken = () => localStorage.getItem("token");
const stokenExpire = localStorage.getItem("tokenExpire");
let isTokenExpiredErrorHandled = false;

const GetHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${GetToken()}`
})

const GetUploadHeaders = () => ({
    'Authorization': `Bearer ${GetToken()}`
})

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (!isTokenExpiredErrorHandled && (error.response.status == 401 || error.response.status == 503)) {
            if (stokenExpire !== null) {
                const tokenExpireDate = new Date(stokenExpire);
                const now = new Date(Date.now());
                if (tokenExpireDate <= now) {
                    isTokenExpiredErrorHandled = true;
                    getErrorToast('Oturum süreniz dolmuştur. Giriş sayfasına yönlendiriliyorsunuz.');

                    setTimeout(function () {
                        SignOut();
                    }, 1000);
                }
            }
        } else if (error.response.status == 403) {
            window.location.replace("/error/authority");
        }
        return Promise.reject(error);
    }
);

/**
 * Gets list of records
 * @param path string Path
*/
const GetList: any = (path: string) => {
    return axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_LINK}/${path}`,
        headers: GetHeaders()
    });
}

/**
 * Gets without id
 * @param path string Path
*/
const GetWithoutId: any = (path: string) => {
    return axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_LINK}/${path}`,
        headers: GetHeaders()
    });
}

/**
 * Gets only one record
 * @param path string Path
 * @param id number Record id
*/
const Get: any = (path: string, id: number) => {
    return axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_LINK}/${path}/${id}`,
        headers: GetHeaders()
    });
}

/**
 * Gets only one record
 * @param path string Path
 * @param model string model
*/
const GetByString: any = (path: string, model: string) => {
    return axios({
        method: 'POST',
        url: `${process.env.REACT_APP_API_LINK}/${path}`,
        headers: GetHeaders(),
        data: model
    });
}

/**
 * Adds record
 * @param paths string Path
 * @param model any Model
*/
const Add: any = (path: string, model: any) => {
    return axios({
        method: 'POST',
        url: `${process.env.REACT_APP_API_LINK}/${path}`,
        headers: GetHeaders(),
        data: model
    });
}

/**
 * Updates record
 * @param paths string Path
 * @param model any Model
*/
const Update: any = (path: string, model: any) => {
    return axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_LINK}/${path}`,
        headers: GetHeaders(),
        data: model
    });
}

/**
 * Partially updates the record with given id
 * @param paths string Path
 * @param id number Record id
 * @param model any Model
 * 
*/
const PartialUpdate: any = (path: string, id: number, model: any) => {
    return axios({
        method: 'PATCH',
        url: `${process.env.REACT_APP_API_LINK}/${path}/${id}`,
        headers: GetHeaders(),
        data: model
    });
}
/**
 * Partially updates the record with given id
 * @param paths string Path
 * @param model any Model
 * 
*/
const PartialUpdateOnlyModel: any = (path: string, model: any) => {
    return axios({
        method: 'PATCH',
        url: `${process.env.REACT_APP_API_LINK}/${path}`,
        headers: GetHeaders(),
        data: model
    });
}
/**
 * Deletes record
 * @param paths string Path
 * @param id number Record id
*/
const Delete: any = (path: string, id: number) => {
    return axios({
        method: 'DELETE',
        url: `${process.env.REACT_APP_API_LINK}/${path}/${id}`,
        headers: GetHeaders()
    });
}

/**
 * Deletes record
 * @param paths string Path
 * @param id number Record id
*/
const DeleteWithModel: any = (firstPath: string, id: number, model: any) => {
    return axios({
        method: 'DELETE',
        url: `${process.env.REACT_APP_API_LINK}/${firstPath}/${id}`,
        headers: GetHeaders(),
        data: model
    });
}

/**
 * Gets list of records
 * @param firstPath string Path
 * @param id number Record id
 * @param secondPath string Path
*/
const GetListById: any = (firstPath: string, secondPath: string, id: number) => {
    return axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_LINK}/${firstPath}/${secondPath}/${id}`,
        headers: GetHeaders()
    });
}

/**
 * Gets list of records
 * @param firstPath string Path
 * @param id number Record id
 * @param secondPath string Path
 * @param thirdPath string Path
*/
const GetListByIdWithThirdPath: any = (firstPath: string, id: number) => {
    return axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_LINK}/${firstPath}/${id}`,
        headers: GetHeaders()
    });
}

/**
 * Download File
 * @param paths string Path
 * @param fileName string File Name
 * @returns 
 */
const Download: any = (paths: string[], fileName: string) => {
    return axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_LINK}/${paths.filter(p => p.length > 0).join("/")}`,
        headers: GetHeaders(),
        responseType: 'blob'
    }).then((response) => {
        const href = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    });
}

const GetFileContent: any = (paths: string[], callback: any) => {
    return axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_LINK}/${paths.filter(p => p.length > 0).join("/")}`,
        headers: GetHeaders(),
        responseType: 'blob'
    }).then((response) => {
        if (callback)
            callback(response.data);
    });
}

/**
 * Download File
 * @param path string Path
 * @returns 
 */
const DownloadWithoutFilename: any = (path: string) => {
    window.location.href = `${process.env.REACT_APP_API_LINK}/${path}`;
}

/**
 * Export File
 * @param paths string Path
 * @param fileName string File Name
 * @returns 
 */
const ExportData: any = (paths: string[], fields: Export, fileName: string) => {
    return axios({
        method: 'POST',
        url: `${process.env.REACT_APP_API_LINK}/${paths.filter(p => p.length > 0).join("/")}`,
        headers: GetHeaders(),
        data: fields,
        responseType: 'blob'
    }).then((response) => {
        const href = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    });
}

/**
 * Adds record
 * @param paths string Path
 * @param model any Model
*/
const AddWithFile: any = (path: string, model: any) => {
    return axios({
        method: 'POST',
        url: `${process.env.REACT_APP_API_LINK}/${path}`,
        headers: GetUploadHeaders(),
        data: model
    });
}

/**
 * Adds record
 * @param paths string Path
 * @param model any Model
*/
const UpdateWithFile: any = (path: string, model: any) => {
    return axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_LINK}/${path}`,
        headers: GetUploadHeaders(),
        data: model
    });
}

export { GetFileContent, GetList, GetWithoutId, Get, Add, Update, PartialUpdate, Delete, GetByString, DeleteWithModel, Download, GetListByIdWithThirdPath, GetListById, ExportData, PartialUpdateOnlyModel, DownloadWithoutFilename, AddWithFile, UpdateWithFile }